import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gerion_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const tenantOverride = localStorage.getItem("gerion_tenant_override");
  if (tenantOverride) {
    config.headers["X-Tenant-Override"] = tenantOverride;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("gerion_token");
      localStorage.removeItem("gerion_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
